export default __webpack_public_path__ + "static/media/Redux.543b98d3.png";